
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";


export const POST_PRODUCTS_REQUEST = "POST_PRODUCTS_REQUEST";
export const POST_PRODUCTS_SUCCESS = "POST_PRODUCTS_SUCCESS";
export const POST_PRODUCTS_FAILURE = "POST_PRODUCTS_FAILURE";


export const PATCH_PRODUCTS_REQUEST = "PATCH_PRODUCTS_REQUEST";
export const PATCH_PRODUCTS_SUCCESS = "PATCH_PRODUCTS_SUCCESS";
export const PATCH_PRODUCTS_FAILURE = "PATCH_PRODUCTS_FAILURE";

export const DELETE_PRODUCTS_REQUEST = "DELETE_PRODUCTS_REQUEST";
export const DELETE_PRODUCTS_SUCCESS = "DELETE_PRODUCTS_SUCCESS";
export const DELETE_PRODUCTS_FAILURE = "DELETE_PRODUCTS_FAILURE";

